import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import swal from 'sweetalert2';
import { AddEditAiCallConfigComponent } from './addEditAiCallConfig.component';
import { AiCallConfigService } from '../../../services/index';

@Component({
    selector: 'ai-call-config-tab',
    templateUrl: './aiCallConfig.component.html',
})
export class AiCallConfigMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    isLoadMask: Promise<any>;
    loadingIndicator = true;
    reorderable = true;
    suppressPaging = false;
    filterExpand = false;
    filterData = { search_data: '' };

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'config_id',
        orderDir: 'desc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('activeTemplate') activeTemplate: TemplateRef<any>;
    @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;

    columns = [];
    configData: any[] = [];
    bsModalRef: BsModalRef;

    constructor(private aiCallConfigService: AiCallConfigService, private modalService: BsModalService) {}

    ngOnInit() {
        this.columns = [
            { name: 'SNo',         prop: 'sno',          width: 60,  minWidth: 60,  maxWidth: 60,  cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Agent ID',    prop: 'agent_id',     width: 280, minWidth: 280, maxWidth: 280 },
            { name: 'Campaign ID', prop: 'campaign_id',  width: 280, minWidth: 280, maxWidth: 280 },
            { name: 'From Number', prop: 'from_number',  width: 140, minWidth: 140, maxWidth: 140 },
            { name: 'API URL',     prop: 'api_url',      width: 280, minWidth: 280, maxWidth: 280 },
            { name: 'Retries',     prop: 'retries',      width: 80,  minWidth: 80,  maxWidth: 80,  cellClass: 'cell-center' },
            { name: 'Active',      prop: 'is_active',    width: 90,  minWidth: 90,  maxWidth: 90,  cellClass: 'cell-center', sortable: false, cellTemplate: this.activeTemplate },
            { name: 'Action',      prop: 'config_id',    width: 80,  minWidth: 80,  maxWidth: 80,  cellClass: 'cell-center', sortable: false, cellTemplate: this.actionTemplate }
        ];
        this.pageCallback({ offset: 0 });
    }

    pageCallback(pageInfo: any) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getList();
        }
    }

    onOpenedFilter() {}

    clearFilter() {
        this.filterData = { search_data: '' };
        this.applyFilter();
    }

    applyFilter() {
        this.filterPanel.close();
        this.getList();
    }

    @ViewChild('filterPanel') filterPanel;

    sortCallback(sortInfo: any) {
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.page.orderBy  = sortInfo.sorts[0].prop;
        this.getList();
    }

    onChangePageSize(limit: number) {
        this.page.limit = limit;
        this.getList();
    }

    getList() {
        const params = {
            start:       `${this.page.offset}`,
            limit:       `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir:    `${this.page.orderDir}`,
            filter:      JSON.stringify(this.filterData)
        };
        this.isLoadMask = this.aiCallConfigService.getList(params).then((res: any) => {
            this.loadingIndicator = false;
            this.page.count  = res.totCnt;
            this.configData  = res.data;
        });
    }

    onAddEdit(mode: string, row: any) {
        this.bsModalRef = this.modalService.show(AddEditAiCallConfigComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        this.bsModalRef.content.title      = mode + ' AI Call Config';
        this.bsModalRef.content.configData = Object.assign({}, row);
        this.bsModalRef.content.loadEvent.subscribe(() => { this.getList(); });
    }

    onToggleActive(row: any) {
        const newVal = row.is_active ? 0 : 1;
        const label  = newVal ? 'Activate' : 'Deactivate';
        swal({
            title: 'Are you sure?',
            text: label + ' this config?',
            showCancelButton: true,
            confirmButtonText: 'Yes, ' + label,
            cancelButtonText: 'Cancel'
        }).then(() => {
            this.isLoadMask = this.aiCallConfigService.toggleActive({ config_id: row.config_id, is_active: newVal }).then((res: any) => {
                if (res.success) {
                    this.getList();
                } else {
                    swal('ERROR', res.message, 'error');
                }
            });
        }, () => {});
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/aiCallConfig/aiCallConfig.component.ts